import axios from 'axios';

import config from './env';


export const isvApi = axios.create({
    baseURL: config.APIURL,
    headers: {
        'Content-Type': 'application/json',
    },
});

const apiBasePrefix = 'api/v1/';

export const API_URL = {
    contries: `${apiBasePrefix}countries`,
    URLGenerator: `${apiBasePrefix}pilots/url-generator`,
    getClientData: `${apiBasePrefix}pilots/info-form`,
    acceptTerms: `${apiBasePrefix}pilots/accept-terms`,
    clientPortals: `${apiBasePrefix}pilots/client-portals`,
    portalInfo: `${apiBasePrefix}downloads/v1/portals`,
    confidentTerms: `${apiBasePrefix}pilots/confident-terms`,
};